import React from 'react'
import { Grid, Box, TextField, InputAdornment } from '@material-ui/core'
import { Controller } from 'react-hook-form'

import { Dai, Label } from 'components'

import brlIcon from 'images/brazilian-real-sign-solid.svg'

import helpers from 'helpers'

const Asking = ({
  planAction,
  control,
  errors,
  isDisabled,
  changeParameters = false,
}) => {
  const TextFieldComponent = planAction?.generatedByAi
    ? Dai.TextField
    : TextField

  const getFieldName = (baseName) =>
    changeParameters ? baseName : `${baseName}Question`

  return (
    <Grid item xs={12}>
      <Box m={(2, 2, 0, 2)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label
              title="O que"
              description="Ações concretas e objetivas que serão tomadas"
              marginTopChildren={0}
            >
              <Controller
                as={
                  <TextFieldComponent
                    type="text"
                    color="primary"
                    variant="outlined"
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={!!errors[getFieldName('what')]}
                    helperText={errors?.[getFieldName('what')]?.message}
                    fullWidth
                    disabled={isDisabled}
                  />
                }
                control={control}
                name={getFieldName('what')}
                mode="onBlur"
              />
            </Label>
          </Grid>
          <Grid item xs={12}>
            <Label
              title="Como"
              description="Planejamento para execução da ação"
              marginTopChildren={0}
            >
              <Controller
                as={
                  <TextFieldComponent
                    type="text"
                    color="primary"
                    variant="outlined"
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={!!errors[getFieldName('how')]}
                    helperText={errors?.[getFieldName('how')]?.message}
                    fullWidth
                    disabled={isDisabled}
                  />
                }
                control={control}
                name={getFieldName('how')}
                mode="onBlur"
              />
            </Label>
          </Grid>
          <Grid item xs={12}>
            <Label
              title="Porquê"
              description="A meta que se objetiva com a ação"
              marginTopChildren={0}
            >
              <Controller
                as={
                  <TextFieldComponent
                    type="text"
                    color="primary"
                    variant="outlined"
                    multiline
                    minRows={3}
                    maxRows={10}
                    error={!!errors[getFieldName('because')]}
                    helperText={errors?.[getFieldName('because')]?.message}
                    fullWidth
                    disabled={isDisabled}
                  />
                }
                control={control}
                name={getFieldName('because')}
                mode="onBlur"
              />
            </Label>
          </Grid>
          <Grid item xs={6}>
            <Label
              title="Onde"
              description="Em qual setor a ação será realizada"
              marginTopChildren={0}
            >
              <Controller
                as={
                  <TextField
                    type="text"
                    color="primary"
                    variant="outlined"
                    error={!!errors[getFieldName('where')]}
                    helperText={errors?.[getFieldName('where')]?.message}
                    fullWidth
                    disabled={isDisabled}
                  />
                }
                control={control}
                name={getFieldName('where')}
                mode="onBlur"
              />
            </Label>
          </Grid>
          <Grid item xs={6}>
            <Label
              title="Quanto"
              description="Impacto financeiro da ação"
              marginTopChildren={0}
            >
              <Controller
                as={
                  <TextField
                    type="text"
                    color="primary"
                    variant="outlined"
                    error={!!errors[getFieldName('howPrice')]}
                    helperText={errors?.[getFieldName('howPrice')]?.message}
                    fullWidth
                    disabled={isDisabled}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={brlIcon} alt="Logo" width={15} />
                        </InputAdornment>
                      ),
                    }}
                  />
                }
                control={control}
                name={getFieldName('howPrice')}
                mode="onChange"
                onChange={([event]) => {
                  return helpers.formatters.currencyInput(
                    event.target.value || '0',
                  )
                }}
              />
            </Label>
          </Grid>
          <Grid item xs={12}>
            <Label
              title="Link"
              description="Upload de documento e/ou link"
              marginTopChildren={0}
            >
              <Controller
                as={
                  <TextField
                    type="text"
                    color="primary"
                    variant="outlined"
                    error={!!errors.link}
                    helperText={errors?.link?.message}
                    fullWidth
                    disabled={isDisabled}
                  />
                }
                control={control}
                name="link"
                mode="onBlur"
              />
            </Label>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  )
}

export default Asking
